import { render, staticRenderFns } from "./ProfileEditHistoryRow.vue?vue&type=template&id=baff6cfe"
import script from "./ProfileEditHistoryRow.vue?vue&type=script&lang=js"
export * from "./ProfileEditHistoryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports